import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { withJsonpSupport, withInterceptors } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { EncuestaPageComponent } from './pages/encuesta-page/encuesta-page.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import { ScaleComponent } from './components/scale/scale.component';
import { SingleSelectionComponent } from './components/single-selection/single-selection.component';
import { MainFooterComponent } from './components/main-footer/main-footer.component';
import { CompletePageComponent } from './pages/complete-page/complete-page.component';
import { MultipleOptionComponent } from './components/multiple-option/multiple-option.component';
import { PreguntaItemComponent } from './components/pregunta-item/pregunta-item.component';

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    EncuestaPageComponent,
    SpinnerComponent,
    ToastsComponent,
    ScaleComponent,
    SingleSelectionComponent,
    MainFooterComponent,
    CompletePageComponent,
    MultipleOptionComponent,
    PreguntaItemComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule
  ],
  providers: [
    provideFirebaseApp(() => initializeApp({"projectId":"cleversec-encuestas","appId":"1:274352004450:web:2518f957b44166c8ed203b","storageBucket":"cleversec-encuestas.firebasestorage.app","apiKey":"AIzaSyDByXnwr36xmcj9hrCw9DzZw8dBsaPDPlE","authDomain":"cleversec-encuestas.firebaseapp.com","messagingSenderId":"274352004450","measurementId":"G-MYDYX8MXCB"})),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    provideHttpClient(withJsonpSupport()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
